import * as React from 'react';
import { ContactEntityType } from '@nkr/enums/index';
import { Alert, Col, Row } from 'react-bootstrap';
import { IValidation } from './validation';

interface IProps {
    validation: IValidation,
    entityType: ContactEntityType,
    positions: number[]
}

const ValidationInfo: React.FunctionComponent<IProps> = (props) => {
    const { entityType, positions, firstName, lastName, email, primaryAddress, primaryAddressOverride, phoneNumbers, conferenceNumber, conferenceNumberCode, conferenceNumberMobileFriendly } = props.validation;
    const primaryAddressOverrideValid = primaryAddressOverride.street && primaryAddressOverride.city && primaryAddressOverride.state && primaryAddressOverride.postalCode;
    const primaryAddressValid = props.entityType == ContactEntityType.Center ? primaryAddress : primaryAddressOverrideValid;

    // Helper function to check if conference call information is required
    const requiresConferenceCall = (positions: number[]): boolean => {
        return positions.includes(11) || positions.includes(8) || positions.includes(15);
    };

    // Conference call information is required for Operations (11), Swap Managers (8), and Duty Officers (15)
    const needsConferenceCall = props.positions && requiresConferenceCall(props.positions);

    return (
        <Row>
            <Col xs={12} lg={12}>
                <Alert bsStyle='danger'>
                    The following issues were found:
                    <ul>
                        {!entityType && (
                            <li>Contact type is required</li>
                        )}

                        {!positions && (
                            <li>At least one role is required</li>
                        )}

                        {!firstName && (
                            <li>First name is required</li>
                        )}

                        {!lastName && (
                            <li>Last name is required</li>
                        )}

                        {!email && (
                            <li>Email address is required</li>
                        )}

                        {!primaryAddressValid && (
                            <li>Primary address is required</li>
                        )}

                        {!phoneNumbers && (
                            <li>At least one phone number is required</li>
                        )}

                        {needsConferenceCall && !conferenceNumber && (
                            <li>Dial-in number is required for this role</li>
                        )}

                        {needsConferenceCall && !conferenceNumberCode && (
                            <li>Secondary access code is required for this role</li>
                        )}

                        {needsConferenceCall && !conferenceNumberMobileFriendly && (
                            <li>Mobile-friendly number is required for this role</li>
                        )}
                    </ul>
                </Alert>
            </Col>
        </Row>
    );
}

export default ValidationInfo;